export default __webpack_public_path__ + "static/media/inst-white.573c5688.svg";